<template>
  <section class="container">
    <div class="header"
      :style="{backgroundImage:'url(' + require('@/assets/payment-related/payment1564@2x.png') + ')'}">
      <div class="header__info">
        <span class="header__info__title">{{
          $enumObject.providerConfig[config.projectName].provider.providerName
        }}</span>
        <span class="header__info__content">-{{
            $enumObject.providerConfig[config.projectName].provider.propagandaInfo
          }}-</span>
      </div>
    </div>
    <h2 class="prompt_tips" style="margin:30px">{{$route.query.cardNumber}}</h2>
    <div class="btn_box" style="margin-top:50px">
      <van-button @click="submit" size="large" class="blue-btn">
        充值
      </van-button>
    </div>

  </section>
</template>

<script>
import { JH_UnderOrderByMiddleware } from '@/api/transaction'
import { parseTime, getUrlParam } from '@/utils'
import config from '@/config/index'
import { isWhatsPayWay } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'Pay-Parking-Cost',
  components: {},
  data () {
    return {
      config, //全局项目配置信息
      plateNumber: [],
    }
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'zfb_userInfo', 'wx_token', 'token'])
  },
  methods: {
    change (val) {
      this.plateNumber = val
    },
    submit () {
      let _this = this
      _this.under_Order_Loading = _this.$toast.loading('加载中...')
      let params = {
        discountMoney: 0, //折扣金额
        chargeMoney: getUrlParam('paidMoney'), //应收金额
        cardNumber: _this.$route.query.cardNumber, //车牌号
        parkId: getUrlParam('parkId'), //停车场Id,
        parkingNumber: "",//车位号
        parkName: "押金", //停车场名称
        orderType: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//订单类型 1 停车场  2 路边 3预约 4 关系 5 包月
        orderStatus: 0,//订单状态
        billingStatus: 0,//开票状态
        payType: 63,
        orderPayTime: parseTime(new Date()),
        wxOpenid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        otherId: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        zfbUserid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        otherPlatformId: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        returnUrl: `http://${document.domain}/jn-pay-result`,
        platformId: getUrlParam('chargeId'), //停车记录id
        paidMoney: (getUrlParam('paidMoney') * 100),//实付金额 _this.payMoney
        outTradeNo: `${parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + Math.round(Math.random() * 100)}_${getUrlParam('chargeId')}_2`,
        paidTime: parseTime(new Date()),
        isParkingOrRoadside: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//路内路外
        isJfOrQfbj: "JF",
        // remark: _this.orders.discountType,
        isFieldOrDoorway: "担保押金",
        stayPage: '担保押金支付页面',
        kernel: isWhatsPayWay() == 'WX' ? 1 : 0, //0支付宝 1微信
        notifyUrl: `${config.authBaseURL}/weChat/notifyUrlV3/api/UnionPayCallback`,

        secureTransaction: true,
      }
      JH_UnderOrderByMiddleware(params).then(res => {
        _this.under_Order_Loading.clear()
        if (res.status === 1001) {
          if (res.body.url) {
            window.location.href = window.unescape(res.body.url)
          } else {
            _this.$notify({
              type: 'danger',
              message: res.message
            })
          }
        } else {
          _this.$notify({
            type: 'danger',
            message: res.message
          })
        }
      }).catch(err => {
        _this.under_Order_Loading.clear()
        _this.$notify({
          type: 'danger',
          message: err
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: px2rem(140);
    min-height: px2rem(140);
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &__info {
      width: 70%;
      height: 50%;
      display: flex;
      flex-direction: colunm;
      flex-wrap: wrap;
      align-items: center;

      span {
        color: #fff;
        text-align: center;
      }

      &__title {
        width: 100%;
        font-size: 22px;
        font-weight: 500;
      }

      &__content {
        width: 100%;
        font-size: 18px;
      }
    }
  }

  .prompt_tips {
    font-size: 18px;
    text-align: center;
  }

  .page {
    padding: px2rem(15);
    margin: px2rem(10) 0 px2rem(20);
  }

  .btn_box {
    padding: 0 15px;
  }
}
</style>